/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Styled components for Calls Detail
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.4.0
 */

import styled from 'styled-components';

export const WizardCallsDetailPeriodStyled = styled.div`
    width: 220px;
`;

export const WizardCallsDetailFinalStepContainerStyled = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 32px;
`;
